import axios from "axios";
import { ApiResponse } from "./models";

const baseUrl = process.env.MIDDLEWARE_URL || "";
const httpClient = axios.create({ baseURL: baseUrl });

export class NotaPiauienseService {
  static async listNotas(accessToken: string) {
    const { data } = await httpClient.get<ApiResponse>(
      "/sefaz/nota-piauiense/lista-notas",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "app-key": process.env.APP_KEY || "",
        },
      }
    );

    return data;
  }
}
